define('data-entry/upload-csv.controller',['angular'], function (angular) {
    'use strict';
    var DataEntryUploadCsvCtrl = function ($scope, userService, user, dataEntryService, $q, $log, $mdToast, $location) {
        $scope.listView = function(){
            $location.path('/data-entry/list');
        };
        $scope.user = user.data.User;
        $scope.retrieveOrg = function (l) {
            return dataEntryService.retrieveOrg($scope.user.sessionID, l).then(function (data) {
                return data;
            }, function (e) {
                return [];
            });
        };
        var self = this;
        $scope.noCache = true;
        $scope.simulateQuery = false;
        $scope.isDisabled = false;
        $scope.selectedItem = undefined;
        $scope.searchTextChange = function (text) {
            $scope.selectedItem = undefined;
            $log.info('Text changed to ' + text);
        };
        $scope.selectedItemChange = function (item) {
            $scope.selectedItem = item;
            $log.info('Item changed to ' + JSON.stringify(item));
        };
        $scope.uploadABBYYForm = function () {
            $scope.myPromise = dataEntryService.uploadABBYYCsv($scope.csvFile, $scope.user.sessionID, $scope.afNotes, +$location.search().id).then(function (response) {
                $mdToast.show({
                    hideDealy: 10000,
                    position: 'bottom right',
                    controller: 'ToastSuccessCtrl',
                    templateUrl: 'data-entry/upload-success.html'
                });
                $scope.searchText = '';
                $scope.selectedItem = undefined;
                $scope.pdfFile = undefined;
                $scope.csvFile = undefined;
                $scope.afNotes = '';
            });
        };
    };
    DataEntryUploadCsvCtrl.$inject = ['$scope', 'userService', 'user', 'dataEntryService', '$q', '$log', '$mdToast', '$location'];
    return DataEntryUploadCsvCtrl;
});


/**
 Copyright 2016 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that can be foundin the LICENSE file at http://material.angularjs.org/HEAD/license.
 **/;
